import { NavLink } from 'react-router-dom';

/** Login / Register switch on the hidden platform-admin pages. */
export function PlatformAuthTabs() {
  const tab = ({ isActive }: { isActive: boolean }) =>
    `flex-1 text-center py-2 text-sm font-semibold rounded-[8px] transition-colors ${
      isActive
        ? 'bg-[var(--co-surface,#fff)] text-[var(--co-ink)] shadow-sm dark:bg-gray-700 dark:text-white'
        : 'text-gray-500 hover:text-[var(--co-ink)] dark:text-gray-400 dark:hover:text-white'
    }`;

  return (
    <div className="mb-6 flex gap-1 rounded-[10px] bg-gray-100 p-1 dark:bg-gray-800" role="tablist">
      <NavLink to="/platform-admin" end className={tab} role="tab">
        Login
      </NavLink>
      <NavLink to="/platform-admin/register" className={tab} role="tab">
        Register
      </NavLink>
    </div>
  );
}
